import React, { useState, useEffect } from "react";
import { StaticImage } from 'gatsby-plugin-image';
import '../../../sass/components/flexibleModules/homepage/_components.HomepageHeroSectionWithLogos.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const HomepageHeroSectionWithLogos = ({ data }) => {

    useEffect(() => {
        if (data.homepageHeroSectionMainImageVideoModal === 'yes' && data.homepageHeroSectionMainImageVideoModalWistia) {
            var scriptOne = document.createElement('script');
            scriptOne.src = `https://fast.wistia.com/embed/medias/${data.homepageHeroSectionMainImageVideoModalWistia}.jsonp`;
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = 'https://fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    const [videoShow, setVideoShow] = useState(false);

    const showVideo = (val) => {
        setVideoShow(val);
    }

    return (
        <div className="cp-homepageHeroSectionWithLogos l-homepage">
            <div className="cp-homepageHeroSectionWithLogos__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.homepageHeroSectionWithLogosHeader &&
                    <h1>{data.homepageHeroSectionWithLogosHeader}</h1>
                }
                {data.homepageHeroSectionWithLogosTeaser &&
                    <div className="l-teaser" dangerouslySetInnerHTML={{ __html: data.homepageHeroSectionWithLogosTeaser }} />
                }
                {data.homepageHeroSectionButtons &&
                    <div className="cp-homepageHeroSectionWithLogos__buttons l--flex">
                        {data.homepageHeroSectionButtons.map((buttonItem, index) => (
                            <React.Fragment key={index}>
                                {buttonItem.button &&
                                    <>
                                        {buttonItem.button.url.substr(-1) !== '/' ?
                                            <a className={`${index === 1 ? "l-textlink" : "l-button"}`} key={index} href={`${buttonItem.button.url + '/'}`} target={buttonItem.button.target}>
                                                <span dangerouslySetInnerHTML={{ __html: buttonItem.button.title }} />
                                            </a>
                                            :
                                            <a className={`${index === 1 ? "l-textlink" : "l-button"}`} key={index} href={buttonItem.button.url} target={buttonItem.button.target}>
                                                <span dangerouslySetInnerHTML={{ __html: buttonItem.button.title }} />
                                            </a>
                                        }
                                    </>
                                }
                            </React.Fragment>
                        ))}
                    </div>
                }
                {data.homepageHeroSectionMainImage &&
                    <div className="l--mainImage">
                        {data.homepageHeroSectionMainImageVideoModal === 'yes' ?
                            <>
                                <button onClick={() => showVideo(true)} className="l--flex">
                                    <GatsbyImage image={getImage(data.homepageHeroSectionMainImage.gatsbyImage)} alt={data.homepageHeroSectionMainImage.altText} />
                                </button>
                                {videoShow &&
                                    <div className="l-videoPopup">
                                        <div className="l-videoPopup__inner">
                                            {data.homepageHeroSectionMainImageVideoModalWistia ?
                                                <div className={`wistia_embed wistia_async_${data.homepageHeroSectionMainImageVideoModalWistia} autoPlay=true`}>&nbsp;</div>
                                                :
                                                <>
                                                    {data.homepageHeroSectionMainImageVideoModalYoutube &&
                                                        <iframe width="560" height="315" src={`https://www.youtube.com/embed/${data.homepageHeroSectionMainImageVideoModalYoutube}?autoplay=1&rel=0`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                                    }
                                                </>
                                            }
                                            <button className="cp-wistiaVideo__close" onClick={() => showVideo(false)}>
                                                <StaticImage src="../../../images/video-close-icon.svg" alt=""></StaticImage>
                                            </button>
                                        </div>
                                        <button className="cp-wistiaVideo__closebg" onClick={() => showVideo(false)}>Close Video</button>
                                    </div>
                                }
                            </>
                            :
                            <>
                                {data.homepageHeroSectionMainImageLink ?
                                    <a href={data.homepageHeroSectionMainImageLink.url} target={data.homepageHeroSectionMainImageLink.target}>
                                        <GatsbyImage image={getImage(data.homepageHeroSectionMainImage.gatsbyImage)} alt={data.homepageHeroSectionMainImage.altText} />
                                    </a>
                                    :
                                    <GatsbyImage image={getImage(data.homepageHeroSectionMainImage.gatsbyImage)} alt={data.homepageHeroSectionMainImage.altText} />
                                }
                            </>
                        }
                    </div>
                }
                {data.homepageHeroSectionLogos &&
                    <div className="cp-homepageHeroSectionWithLogos__logos l--flex">
                        {data.homepageHeroSectionLogos.map((logos, index) => (
                            <div key={index}>
                                {logos.altText ?
                                    <a href={logos.altText}>
                                        <img width="160" height="60" loading="lazy" key={index} src={logos.sourceUrl} alt={logos.altText} />
                                    </a>
                                    :
                                    <img width="160" height="60" loading="lazy" key={index} src={logos.sourceUrl} alt={logos.altText} />
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default HomepageHeroSectionWithLogos;